import { render, staticRenderFns } from "./index-malaysia.vue?vue&type=template&id=411c23e1&scoped=true&"
import script from "./index-malaysia.vue?vue&type=script&lang=ts&"
export * from "./index-malaysia.vue?vue&type=script&lang=ts&"
import style0 from "./index-malaysia.vue?vue&type=style&index=0&id=411c23e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411c23e1",
  null
  
)

export default component.exports